import { AbsoluteLayout, Component } from '@wix/thunderbolt-becky-types'

export type PinnedPositions =
	| 'TOP_LEFT'
	| 'TOP_CENTER'
	| 'TOP_RIGHT'
	| 'CENTER_LEFT'
	| 'CENTER_RIGHT'
	| 'BOTTOM_LEFT'
	| 'BOTTOM_CENTER'
	| 'BOTTOM_RIGHT'

export type PinnedChildrenByPositionMap = Partial<Record<PinnedPositions, Array<string>>>

export const isFixed = (compLayout: Component['layout']) => compLayout && compLayout.fixedPosition
const isPinned = (compLayout: Partial<AbsoluteLayout>) => isFixed(compLayout) && !!compLayout.docked

const getPinnedPosition = (compLayout: Partial<AbsoluteLayout>): PinnedPositions => {
	const dockedData = compLayout.docked || {}

	if (dockedData.top) {
		// pinned to top
		if (dockedData.hCenter) {
			return 'TOP_CENTER'
		} else {
			return dockedData.left ? 'TOP_LEFT' : 'TOP_RIGHT'
		}
	} else if (dockedData.vCenter) {
		// pinned to center
		return dockedData.left ? 'CENTER_LEFT' : 'CENTER_RIGHT'
	} else {
		// pinned to bottom
		if (dockedData.hCenter) {
			return 'BOTTOM_CENTER'
		} else {
			return dockedData.left ? 'BOTTOM_LEFT' : 'BOTTOM_RIGHT'
		}
	}
}

export const createComponent = (
	id: string,
	components: Array<string>,
	parent: string,
	componentType: string,
	type: string = 'Component'
) =>
	({
		id,
		components,
		componentType,
		layout: {},
		type,
		parent,
		styleId: '',
		metaData: {},
		skin: '',
	} as Component)

export const checkIfPinnedComponentAndAddToMap = (
	childId: string,
	childLayout: Component['layout'],
	pinnedChildrenByPosition: PinnedChildrenByPositionMap
) => {
	if (isPinned(childLayout)) {
		const pinnedPosition = getPinnedPosition(childLayout)
		pinnedChildrenByPosition[pinnedPosition] = pinnedChildrenByPosition[pinnedPosition] || []
		pinnedChildrenByPosition[pinnedPosition]!.push(childId)

		return true
	}
	return false
}
